import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CKEditorModule } from 'ng2-ckeditor';

import { AngularMailComposerComponent } from './angular-mail-composer.component';
import { AngularFileUploadModule } from '../file-upload/file-upload.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CKEditorModule,
        AngularFileUploadModule
    ],
    declarations: [AngularMailComposerComponent],
    exports: [AngularMailComposerComponent],
    providers: []
})
export class AngularMailComposerModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/mail-composer/angular-mail-composer.module.ts